// extracted by mini-css-extract-plugin
export var activeDot = "_1z-c";
export var buttonContainer = "_1z-9";
export var channelButton = "_1z-a";
export var content = "_1z-0";
export var contentFull = "_1z-2";
export var contentThird = "_1z-1";
export var contentWrapper = "_1z-7";
export var description = "_1z-5";
export var heightShort = "_1z-e";
export var image = "_1z-3";
export var imageContainer = "_1z-4";
export var selectButton = "_1z-d";
export var spinnerContainer = "_1z-b";
export var titleContent = "_1z-8";
export var titleWrapper = "_1z-6";